import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ADMIN_DASHBOARD } from '@ApplicationWide/permissions/constants';
import React from 'react';

const RoleChangePage = React.lazy(() => import('../../../pages/Admin/RoleChange'));

export default [
  {
    group: ADMIN,
    route: ['/administration/role-change', '/administration/role-change/:userId'],
    component: RoleChangePage,
    requiredRoles: ['admin', 'super_admin', 'manager'],
    adminVisibilityPermission: ADMIN_DASHBOARD,
    hasNavBar: true,
  },
];
